import { type TypedDocumentNode, gql } from '@apollo/client';

import {
  BenchPlayerScore,
  Sport,
} from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';

import { CardFooter } from 'components/card/CardFooter';

import type { TokenXpDetails_anyCard } from './__generated__/index.graphql';

type Props = {
  anyCard: TokenXpDetails_anyCard;
  onInfoClick?: () => void;
};

export const TokenXpDetails = ({ anyCard, onInfoClick }: Props) => {
  const { sport } = useSportContext();
  const {
    flags: { useMlbSeasonAverageScore = true },
  } = useFeatureFlags();

  const modePerSport: Record<Sport, BenchPlayerScore> = {
    [Sport.FOOTBALL]: BenchPlayerScore.LAST_FIFTEEN_SO5_AVERAGE_SCORE,
    [Sport.NBA]: BenchPlayerScore.LAST_TEN_PLAYED_SO5_AVERAGE_SCORE,
    [Sport.BASEBALL]: useMlbSeasonAverageScore
      ? BenchPlayerScore.SEASON_AVERAGE_SCORE
      : BenchPlayerScore.LAST_FIFTEEN_SO5_AVERAGE_SCORE,
  };
  const mode = modePerSport[sport];

  return (
    <CardFooter
      anyCard={anyCard}
      benchPlayerScore={mode}
      onClick={onInfoClick}
    />
  );
};

TokenXpDetails.fragments = {
  anyCard: gql`
    fragment TokenXpDetails_anyCard on AnyCardInterface {
      slug
      tokenOwner {
        id
        transferType
      }
      ...CardFooter_anyCardInterface
    }
    ${CardFooter.fragments.anyCardInterface}
  ` as TypedDocumentNode<TokenXpDetails_anyCard>,
};
